module.exports = __webpack_public_path__ + "static/img/banner04.063e835a.png";